export const COLOR_THEME_OPTIONS = [
  {
    value: 'amber',
    label: '琥珀',
    description: '经典暖橙，醒目耐看',
    swatch: '#ff9d47',
    glow: '#ffd17d',
  },
  {
    value: 'ocean',
    label: '海蓝',
    description: '冷静清爽，适合长时间剪辑',
    swatch: '#58a9ff',
    glow: '#7fd1ff',
  },
  {
    value: 'emerald',
    label: '青绿',
    description: '通透干净，层次感更强',
    swatch: '#45d39c',
    glow: '#89f0c0',
  },
  {
    value: 'rose',
    label: '玫红',
    description: '更有活力，强调操作反馈',
    swatch: '#ff5f8f',
    glow: '#ff92b3',
  },
  {
    value: 'violet',
    label: '紫晶',
    description: '偏冷高级，适合深色工作台',
    swatch: '#8d7dff',
    glow: '#b9acff',
  },
  {
    value: 'sky',
    label: '天青',
    description: '明亮通透，信息感更轻',
    swatch: '#49c6ff',
    glow: '#89e0ff',
  },
  {
    value: 'lime',
    label: '青柠',
    description: '偏亮偏新，适合高对比操作',
    swatch: '#8fdb39',
    glow: '#c4f16e',
  },
  {
    value: 'copper',
    label: '赤铜',
    description: '沉稳偏暖，接近电影调性',
    swatch: '#d8874b',
    glow: '#f0b277',
  },
] as const

export type ColorTheme = (typeof COLOR_THEME_OPTIONS)[number]['value']

export const COLOR_THEME_VALUES = COLOR_THEME_OPTIONS.map((option) => option.value)

export function isColorTheme(value: unknown): value is ColorTheme {
  return typeof value === 'string' && COLOR_THEME_VALUES.includes(value as ColorTheme)
}